export enum InvoiceStatusEnum {
  Rated = "rated",
  Generated = "generated",
  ReadyToPost = "ready_to_post",
  Posted = "posted",
  Synced = "synced",
}

export enum BillingMethodEnum {
  Direct = "direct",
  Factoring = "factoring",
}

export type InvoiceCustomer = {
  id: number;
  name: string;
  sendUpdates: boolean;
  paymentType: BillingMethodEnum;
  billingAddressLine: string | null;
  billingAddressCity: string | null;
  billingAddressState: string | null;
  billingAddressZipCode: string | null;
  billingAddressCountry: string | null;
};

export type InvoiceOrderStop = {
  id: string;
  type: string;
  position: number;
  facilityId: number;
  facilityName: string;
  facilityAddress: string;
  timezone: string;
  timeType: string;
  timeFrom: string | null;
  timeTo: string | null;
};

export type Invoice = {
  id: string;
  createdAt: string;
  number: string;
  status: InvoiceStatusEnum;
  sequence: number;
  version: number;
  isActive: boolean;
  parentId: string | null;
  batchId: string | null;
  companyId: number;
  orderId: string;
  customerId: number;
  customer: InvoiceCustomer;
  orderStops: InvoiceOrderStop[];
  orderPaymentsTotal: number;
};
